import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputComponent } from "@components/input/input.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { TreeSelectorComponent } from "@components/tree-selector/tree-selector.component";
import { firstValueFrom } from "rxjs";
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { AreaSelectionMarknadsomrade } from "~app/common/models/areaSelector";
import { LanDTO } from "~app/common/models/distrikt/LanDTO";
import { MottagningsplatsDTO } from "~app/common/models/styrtabeller/MottagningsplatsDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { RegelverkGridService } from "~app/features/regelverk-viol/regelverk-grid.service";
import { RegelverkViolService } from "~app/features/regelverk-viol/regelverk-viol.service";
import { IRegelverkViol3SearchModel, StyrtabellRedovisningshanvisningViewModel } from "../../regelverkViol3.models";
import { RegelverkViol3Service } from "../../regelverkViol3.service";
import { RedovisningshanvisningComponent } from "../redovisningshanvisning.component";

@Component({
    selector: "rask-redovisningshanvisning-search",
    templateUrl: "./redovisningshanvisning-search.component.html",
    styleUrls: ["./redovisningshanvisning-search.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectorComponent,
        FormsModule,
        InputComponent,
        TreeSelectorComponent,
        ButtonComponent,
        RedovisningshanvisningComponent
    ]
})
export class RedovisningshanvisningSearchComponent implements OnInit {
    readonly webbInstallningKey = "regelverkviol3.redovisningshanvisning.filter";

    dataLoaded = false;
    @Input() inmatningshandelssortiment: string;
    lkd: LanDTO[];
    mottagningsplatser: MottagningsplatsDTO[];
    @Input() mottagningsplatsnummer: string;
    searchFilterVerksamhetsOmraden: SelectionItem[] = [];
    searchModel = this.getEmptySearch();
    searchResult: StyrtabellRedovisningshanvisningViewModel[] = [];
    verksamhetsomraden: AreaSelectionMarknadsomrade[];

    private readonly regelverkGridService = inject(RegelverkGridService);
    private readonly regelverkService = inject(RegelverkViolService);
    private readonly regelverkViol3Service = inject(RegelverkViol3Service);

    comparePredicate = (a, b) => a.value === b;

    mottagningsplatsSelectedFormatter = (item) => item?.mottagningsplatsnummer;

    mottagningsplatsViewFormatter = (item) => item.mottagningsplatsnummer ? `${item.mottagningsplatsnummer}: ${item.namn}` : item.namn;

    ngOnInit(): void {
        firstValueFrom(this.regelverkViol3Service.getMottagningsplatser()).then((mottagningsplatser) => {
            this.mottagningsplatser = mottagningsplatser;
            firstValueFrom(this.regelverkViol3Service.getMarknadsOmraden()).then((verksamhetsomradenResponse) => {
                this.verksamhetsomraden = verksamhetsomradenResponse;

                const tmpSearchModel = this.regelverkViol3Service.getSearchFilter(this.webbInstallningKey);
                // Kommer från länk använd queryparams
                if (ObjectUtils.hasValue(this.mottagningsplatsnummer)) {
                    this.searchModel.mottagningsplats = this.mottagningsplatsnummer;
                    this.searchModel.inmatningshandelssortiment = this.inmatningshandelssortiment;
                } else if (tmpSearchModel) {
                    this.searchModel = tmpSearchModel;
                }

                this.searchFilterVerksamhetsOmraden
                    = this.regelverkGridService.mapSelectionItemsVerksamhetsomraden(verksamhetsomradenResponse, this.searchModel.selectedMoRoPo);
                firstValueFrom(this.regelverkViol3Service.getLkd()).then((lkd) => {
                    this.lkd = lkd;
                    this.dataLoaded = true;
                    this.search();
                });
            });
        });
    }

    search() {
        this.searchModel.selectedMoRoPo = this.regelverkService.getSelectedVerksamhetsomraden(this.searchFilterVerksamhetsOmraden);
        this.regelverkViol3Service.saveSearchFilter(this.searchModel, this.webbInstallningKey);
        firstValueFrom(this.regelverkViol3Service.searchRedovisningshanvisning(this.searchModel, this.regelverkService.mapToSelectedVerksamhetsomrade(
            this.searchModel.selectedMoRoPo,
            this.verksamhetsomraden))).then((res) => {
            const tmpSearchresult: StyrtabellRedovisningshanvisningViewModel[] = [];
            res.forEach(x => {
                tmpSearchresult.push(new StyrtabellRedovisningshanvisningViewModel(x, this.verksamhetsomraden, this.lkd));
            });
            this.searchResult = tmpSearchresult;
        });
    }

    private getEmptySearch(): IRegelverkViol3SearchModel {
        return {
            mottagningsplats: undefined,
            mottagare: undefined,
            selectedMoRoPo: [] as any[]
        };
    }
}
